<template>
    <a  :href="url" class="d-block w-100 text-center">
        <font-awesome-icon
                :icon="['fal', 'download']"
                size="lg"
        >
        </font-awesome-icon>
    </a>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({

  computed: {
    url() {
      const { url } = this.params.data;
      return `${url}?token=${this.$store.getters.authToken}`;
    },
  },
});
</script>
